import { render } from "./ArticleComponent.vue?vue&type=template&id=774857cf&scoped=true"
import script from "./ArticleComponent.vue?vue&type=script&lang=js"
export * from "./ArticleComponent.vue?vue&type=script&lang=js"

import "@/assets/css/resources.sass?vue&type=style&index=0&id=774857cf&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774857cf"]])

export default __exports__